import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrowDownOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.328 8.26a1 1 0 0 1 1.413.068l5.259 5.8 5.26-5.8a1 1 0 1 1 1.48 1.344l-6 6.617a1 1 0 0 1-1.48 0l-6-6.617a1 1 0 0 1 .068-1.413Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrowDownOutlined;
